<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-dialog
        v-model="dialog"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="400px"
      >
        <v-card>
          <v-card-text class="text-xs-center">
            <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="problem==null" class="mt-5 mb-2"></v-progress-circular>
            <h3 class="mt-5 mb-3" v-if="problem==null">{{aktualni_stav}}</h3>
            <h3 v-else class="mb-3 mt-3 red--text">{{problem}}</h3>
            <v-btn color="grey" class="mt-3" flat @click="dialog=false" v-if="problem!=null">Zavřít</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <h2 class="mb-2">Nová objednávka výroby</h2>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <dodavatele v-model="dodavatel_id" :selectFirst="true"></dodavatele>
              </v-flex>
            </v-layout>
            <div class="relative">
              <v-layout row wrap v-if="loading">
                <v-flex xs12 class="pt-5 pb-5">
                  <Loader skin="light"></Loader>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="dodavatel_id!=null&&!loading">
                <v-flex xs12>
                  <h3 class="mt-4">Produkty v&nbsp;objednávce</h3>
                  <div class="table-border__radius elevation-1 mt-3">
                    <v-data-table
                      :headers="headers"
                      :items="produkty"
                      :pagination.sync="pagination"
                      :total-items="pagination.totalItems"
                      :rows-per-page-items="[25, 50, 100, 200]"
                      class="no__hover"
                    >
                      <template slot="items" slot-scope="props">
                        <td class="subheading vertical-top pt-4">
                          <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank">
                            {{ props.item.cilovy_produkt.nazev }}
                          </router-link>
                        </td>
                        <td class="text-xs-right subheading vertical-top pt-4"><span v-if="props.item.stav_skladu_fyzicky>0">{{ props.item.stav_skladu_fyzicky | formatInt }}</span><span v-else>--</span></td>
                        <td class="text-xs-right subheading vertical-top pt-4" :class="{'red--text':props.item.stav_skladu_fyzicky<props.item.min_stav_zasoby}"><span v-if="props.item.stav_skladu_nahradni>0">{{ props.item.stav_skladu_nahradni | formatInt }}</span><span v-else>--</span></td>
                        <td class="text-xs-right subheading vertical-top pt-4" :class="{'red--text':props.item.stav_skladu_fyzicky<props.item.min_stav_zasoby}"><span v-if="props.item.stav_na_ceste>0">{{ props.item.stav_na_ceste | formatInt }}</span><span v-else>--</span></td>
                        <td class="text-xs-right subheading vertical-top pt-4" :class="{'red--text':props.item.stav_skladu_fyzicky<props.item.min_stav_zasoby}"><span v-if="props.item.min_stav_zasoby>0">{{ props.item.min_stav_zasoby | formatInt }}</span><span v-else>--</span></td>
                        <td class="text-xs-right subheading vertical-top pt-4" :class="{'red--text':props.item.stav_skladu_fyzicky<props.item.min_stav_zasoby}"><span v-if="props.item.stav_objednane>0">{{ props.item.stav_objednane | formatInt }}</span><span v-else>--</span></td>
                        <td class="subheading" style="min-width: 150px">
                          <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-2 pr-2">
                            <v-layout row wrap>
                              <v-flex xs12 sm12>
                                <v-layout row class="mt-2">
                                  <v-flex xs12 sm12>
                                    <v-text-field
                                      hide-details
                                      class="mb-3 mt-0 mx-2"
                                      v-model="props.item.ks"
                                      :max="props.item.max_ks >= 0 ? props.item.max_ks : 999"
                                      :min="0"
                                      suffix="ks"
                                      type="number"
                                      @input="() => { props.item.g = (props.item.fixovane_mnozstvi - parseInt(props.item.ks) * props.item.vaha_g  - (props.item.nahradni_produkt != null && props.item.nahradni_produkt.ks.toString().length > 0 ? parseInt(props.item.nahradni_produkt.ks) * props.item.nahradni_produkt.vaha_g : 0)).toFixed(2).replace(',', '.'); }"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                  <h3 class="mt-5" v-if="vyrobci != null && vyrobci.length > 0">Objednávka</h3>
                  <v-card v-for="v in vyrobci" :key="'objednavky-'+v.id.toString()" class="grey lighten-3 no__radius mt-3" v-if="vyrobci != null && vyrobci.length > 0">
                    <v-card-text>
                      <v-layout row>
                        <v-flex xs12>
                          <h2>{{v.nazev}}</h2>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-data-table
                            :headers="produktyHeaders"
                            :items="v.produkty"
                            :pagination.sync="pagination"
                            :total-items="pagination.totalItems"
                            :rows-per-page-items="[25, 50, 100, 200]"
                            class="no__hover mt-2 transparent"
                          >
                            <template slot="items" slot-scope="props">
                              <td class="subheading">
                                <router-link :to="{ path: '/produkty/' + props.item.produkt_id }" target="_blank" v-if="props.item.typ=='produkt'">
                                  {{ props.item.nazev }}
                                </router-link>
                                <span v-else>{{ props.item.nazev }}</span>
                              </td>
                              <td class="text-xs-right subheading"><span v-if="props.item.typ=='produkt'">{{ props.item.ks }} ks</span><span v-else>{{ props.item.metal_konto | formatMoney }} g</span></td>
                              <td></td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-card class="grey lighten-3 no__radius mt-3">
                    <v-card-text>
                      <v-layout row>
                        <v-flex xs12>
                          <h2>Stav metal konta</h2>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-data-table
                            :headers="metalKontaHeaders"
                            :items="metal_konta"
                            :pagination.sync="pagination"
                            :total-items="pagination.totalItems"
                            :rows-per-page-items="[25, 50, 100, 200]"
                            class="no__hover mt-2 transparent"
                          >
                            <template slot="items" slot-scope="props">
                              <td class="subheading" :class="{'red--text':props.item.novy_stav<0}">{{ props.item.nazev }}</td>
                              <td class="text-xs-right subheading" :class="{'red--text':props.item.novy_stav<0}">{{ props.item.stav | formatMoney }} g</td>
                              <td class="text-xs-right subheading" :class="{'red--text':props.item.novy_stav<0}">{{ props.item.novy_stav | formatMoney }} g</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-layout row wrap class="mt-5">
                    <v-flex xs12 class="text-xs-center">
                      <v-btn color="green" depressed large dark @click="vytvoritObjednavku" v-if="vyrobci != null && vyrobci.length > 0 && objednavka_ok">Sestavit objednávku</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data: function () {
    return {
      loading: false,
      headers: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: "200px" },
        { text: 'Fyzický sklad', value: 'stav_skladu_fyzicky', sortable: false, width: "180px", align: "right" },
        { text: 'Fyzický sklad - náhradní produkty', value: 'stav_skladu_nahradni', sortable: false, width: "180px", align: "right" },
        { text: 'Na cestě', value: 'stav_na_ceste', sortable: false, width: "180px", align: "right" },
        { text: 'Minimální stav zásoby', value: 'min_stav_zasoby', sortable: false, width: "180px", align: "right" },
        { text: 'Zboží klientů', value: 'stav_objednane', sortable: false, width: "180px", align: "right" },
        { text: 'Objednat', value: 'fixovane_mnozstvi', sortable: false }
      ],
      produktyHeaders: [
        { text: 'Produkt', value: 'nazev', sortable: false, width: "300px" },
        { text: 'Množství', value: 'ks', sortable: false, width: "180px", align: "right" },
        { text: '', value: '', sortable: false, align: "right" }
      ],
      metalKontaHeaders: [
        { text: 'Materiál', value: 'nazev', sortable: false, width: "300px" },
        { text: 'Původní stav konta', value: 'stav', sortable: false, width: "180px", align: "right" },
        { text: 'Nový stav konta', value: 'novy_stav', sortable: false, width: "180px", align: "right" }
      ],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "ks",
        totalItems: 0
      },
      produkty: [],
      vyrobci: [],
      materialy: [],
      dodavatele: [],
      dialog: false,
      aktualni_stav: "",
      problem: null,
      pridat_produkt_id: null,
      loading_produkt: false,
      dodavatel_id: null,
      metal_konta: [],
      objednavka_ok: true
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  watch: {
    produkty: {
      handler (v) {
        this.resolve();
      },
      deep: true
    },
    dodavatel_id () {
      this.loading = true;
      this.load();
    }
  },
  methods: {
    load: function() {
      window.API.get("dodavatele/"+this.dodavatel_id+"/nova-objednavka-vyroby").then(function(b) {
        this.produkty = b.produkty;
        this.materialy = b.materialy;
        this.metal_konta = b.metal_konta;
        this.dodavatele = b.dodavatele.map((e) => {
          return {
            id: e.id,
            nazev: e.nazev,
            produkty: [],
            metal_konto: 0
          };
        });
        this.loading = false;
        this.$nextTick(() => {
          this.resolve();
        });
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    resolve () {
      var $dodavatele = window.th.copy(this.dodavatele);

      this.objednavka_ok = true;

      for (var $i = 0; $i < this.metal_konta.length; $i++) {
        this.metal_konta[$i].novy_stav = this.metal_konta[$i].stav;
      }

      for (var $i = 0; $i < this.produkty.length; $i++) {

        if (parseInt(this.produkty[$i].ks) > 0) {

          var $dodavatel = this.produkty[$i].dodavatel_id;
          var $produkt = this.produkty[$i].cilovy_produkt.id;
          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.id == $produkt; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            $dodavatele[$idx].produkty[$idx_pr].ks += parseInt(this.produkty[$i].ks);
            //$dodavatele[$idx].metal_konto += Math.max(this.produkty[$i].g, 0);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "x" + this.produkty[$i].cilovy_produkt.id,
              typ: "produkt",
              produkt_id: this.produkty[$i].cilovy_produkt.id,
              nazev: this.produkty[$i].cilovy_produkt.nazev,
              ks: parseInt(this.produkty[$i].ks)
            });
            //$dodavatele[$idx].metal_konto += Math.max(this.produkty[$i].g, 0);
          }

          var $material = this.produkty[$i].cilovy_produkt.material.id;
          var $vaha_g = this.produkty[$i].vaha_g;

          var $mf = this.metal_konta.filter((e) => { return e.id == $material; });
          var $idx_mf = this.metal_konta.indexOf($mf[0]);

          this.metal_konta[$idx_mf].novy_stav -= $vaha_g * parseInt(this.produkty[$i].ks);

          if (this.objednavka_ok && this.metal_konta[$idx_mf].novy_stav < 0)
            this.objednavka_ok = false;

        }

      }
      this.vyrobci = $dodavatele.filter((e) => { return e.produkty.length > 0; });
      console.log(this.vyrobci);
    },
    vytvoritObjednavku () {
      this.dialog = true;
      this.aktualni_stav = "Sestavuji objednávku";
      this.problem = null;
      window.API.post("dodavatele/vytvorit-objednavku-vyroby", {
        dodavatele: this.vyrobci
      }).then((b) => {
        if (b.success) {
          this.dialog = false;
          this.e1 = 2;
          this.$router.push({ path: '/dodavatele/objednavky' });
        }
        else {
          this.problem = "Objednávka nemohla být vytvořena.";
        }
      }).catch((e) => {
        this.problem = "Objednávka nemohla být vytvořena.";
        console.log(e);
      })
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dodavatele/DodavateleNovaObjednavkaVyroby.vue